{
    "Un billet vous est proposé — RidoMio": {
        "de": "Ein Ticket wird Ihnen angeboten — RidoMio",
        "en": "A ticket has been offered to you — RidoMio"
    },
    "Un billet vous est proposé. Votre acceptation remplacera le QR initial.": {
        "de": "Ein Ticket wird Ihnen angeboten. Mit Ihrer Annahme wird der bisherige QR-Code ersetzt.",
        "en": "A ticket has been offered to you. Accepting replaces the original QR."
    },
    "Le billet conserve sa place, son tarif et sa facture d’origine. Acceptez avant l’échéance indiquée sur la page.": {
        "de": "Platz, Preis und ursprüngliche Rechnung bleiben unverändert. Nehmen Sie das Ticket vor der auf der Seite angegebenen Frist an.",
        "en": "The ticket keeps its place, price and original invoice. Accept before the deadline shown on the page."
    },
    "Vérifier et accepter le billet": {
        "de": "Ticket prüfen und annehmen",
        "en": "Review and accept the ticket"
    },
    "Vous trouverez votre billet en pièce jointe.": {
        "de": "Ihr Ticket finden Sie im Anhang.",
        "en": "Your ticket is attached."
    },
    "Billets par SMS": {
        "de": "Tickets per SMS",
        "en": "Tickets by SMS"
    },
    "Cette préférence concerne uniquement l’envoi de vos billets. Elle est distincte des communications publicitaires.": {
        "de": "Diese Auswahl betrifft ausschliesslich den Versand Ihrer Tickets. Sie ist unabhängig von Werbung.",
        "en": "This preference only covers delivery of your tickets. It is separate from marketing messages."
    },
    "Votre préférence SMS est enregistrée.": {
        "de": "Ihre SMS-Auswahl wurde gespeichert.",
        "en": "Your SMS preference has been saved."
    },
    "Aucun numéro international compatible. Contactez la billetterie pour corriger votre fiche.": {
        "de": "Keine gültige internationale Telefonnummer. Bitte wenden Sie sich zur Korrektur an die Kasse.",
        "en": "No supported international phone number. Contact the box office to update your details."
    },
    "Demander la réception des billets par SMS": {
        "de": "Ticketversand per SMS wünschen",
        "en": "Request ticket delivery by SMS"
    },
    "Le porteur a confirmé son numéro personnel et demandé cet envoi.": {
        "de": "Die Person hat ihre eigene Nummer bestätigt und diesen Versand gewünscht.",
        "en": "The holder confirmed their own phone number and requested this delivery."
    },
    "Je confirme que ce numéro est le mien et souhaite recevoir mes billets par SMS.": {
        "de": "Ich bestätige, dass dies meine Nummer ist, und wünsche meine Tickets per SMS.",
        "en": "I confirm this is my phone number and would like to receive my tickets by SMS."
    },
    "Enregistrer la préférence SMS": {
        "de": "SMS-Auswahl speichern",
        "en": "Save SMS preference"
    },
    "Proposer un billet à une autre personne": {
        "de": "Ein Ticket einer anderen Person anbieten",
        "en": "Offer a ticket to another person"
    },
    "L’ancien QR reste valable jusqu’à l’acceptation. Ensuite, seul le nouveau QR est utilisable. La facture et le prix restent attachés à la commande d’origine.": {
        "de": "Der bisherige QR-Code bleibt bis zur Annahme gültig. Danach kann nur der neue Code verwendet werden. Rechnung und Preis bleiben bei der ursprünglichen Bestellung.",
        "en": "The original QR remains valid until acceptance. Only the new QR can then be used. The invoice and price stay with the original order."
    },
    "Billet à transférer": {
        "de": "Zu übertragendes Ticket",
        "en": "Ticket to transfer"
    },
    "Choisir un billet": {
        "de": "Ticket auswählen",
        "en": "Choose a ticket"
    },
    "Nom du destinataire": {
        "de": "Nachname der empfangenden Person",
        "en": "Recipient surname"
    },
    "Prénom du destinataire": {
        "de": "Vorname der empfangenden Person",
        "en": "Recipient first name"
    },
    "Email du destinataire": {
        "de": "E-Mail der empfangenden Person",
        "en": "Recipient email"
    },
    "J’ai vérifié le destinataire et lui propose de recevoir ce billet.": {
        "de": "Ich habe die empfangende Person überprüft und biete ihr dieses Ticket an.",
        "en": "I checked the recipient and offer them this ticket."
    },
    "Préparer le transfert du billet": {
        "de": "Ticketübertragung vorbereiten",
        "en": "Prepare ticket transfer"
    },
    "Vos transferts de billets": {
        "de": "Ihre Ticketübertragungen",
        "en": "Your ticket transfers"
    },
    "Envoyer l’invitation au destinataire": {
        "de": "Einladung an die Person senden",
        "en": "Send the invitation to the recipient"
    },
    "Retirer cette proposition de transfert": {
        "de": "Dieses Übertragungsangebot zurückziehen",
        "en": "Withdraw this transfer offer"
    },
    "L’envoi doit être vérifié par la billetterie avant toute nouvelle tentative.": {
        "de": "Die Kasse muss den Versand vor einem erneuten Versuch überprüfen.",
        "en": "The box office must check this delivery before another attempt."
    },
    "Retour à votre espace": {
        "de": "Zurück zu Ihrem Bereich",
        "en": "Back to your account"
    },
    "Transférer un billet": {
        "de": "Ein Ticket übertragen",
        "en": "Transfer a ticket"
    },
    "Les catégories et délais sont fixés par la salle. Pour un billet valable à plusieurs dates, contactez la billetterie.": {
        "de": "Kategorien und Fristen werden vom Veranstalter festgelegt. Für ein an mehreren Daten gültiges Ticket wenden Sie sich bitte an die Kasse.",
        "en": "The venue sets eligible categories and deadlines. Contact the box office for a ticket valid on several dates."
    },
    "Billets précédents": {
        "de": "Vorherige Tickets",
        "en": "Previous tickets"
    },
    "Billets suivants": {
        "de": "Weitere Tickets",
        "en": "Next tickets"
    },
    "Transferts précédents": {
        "de": "Vorherige Übertragungen",
        "en": "Previous transfers"
    },
    "Transferts suivants": {
        "de": "Weitere Übertragungen",
        "en": "Next transfers"
    },
    "Recevoir un billet transféré": {
        "de": "Ein übertragenes Ticket erhalten",
        "en": "Receive a transferred ticket"
    },
    "Votre billet RidoMio": {
        "de": "Ihr RidoMio-Ticket",
        "en": "Your RidoMio ticket"
    },
    "Ce lien est incomplet. Ouvrez le lien reçu dans le message.": {
        "de": "Dieser Link ist unvollständig. Öffnen Sie den Link aus der Nachricht.",
        "en": "This link is incomplete. Open the link you received in the message."
    },
    "Lecture du billet…": {
        "de": "Ticket wird geladen…",
        "en": "Loading ticket…"
    },
    "En acceptant, vous remplacez le QR initial. Le prix, la place et la facture d’origine restent inchangés.": {
        "de": "Mit der Annahme ersetzen Sie den bisherigen QR-Code. Preis, Platz und ursprüngliche Rechnung bleiben unverändert.",
        "en": "Accepting replaces the original QR. The price, place and original invoice remain unchanged."
    },
    "Je suis le destinataire et accepte de recevoir ce billet.": {
        "de": "Ich bin die empfangende Person und nehme dieses Ticket an.",
        "en": "I am the recipient and agree to receive this ticket."
    },
    "Accepter le transfert du billet": {
        "de": "Ticketübertragung annehmen",
        "en": "Accept ticket transfer"
    },
    "Le transfert est accepté. L’ancien QR est révoqué.": {
        "de": "Die Übertragung wurde angenommen. Der bisherige QR-Code ist ungültig.",
        "en": "The transfer is accepted. The original QR has been revoked."
    },
    "Votre billet est disponible.": {
        "de": "Ihr Ticket ist verfügbar.",
        "en": "Your ticket is available."
    },
    "Télécharger le billet PDF": {
        "de": "Ticket als PDF herunterladen",
        "en": "Download PDF ticket"
    },
    "Les billets transférés ne sont plus téléchargeables depuis cette commande. Votre facture reste disponible.": {
        "de": "Übertragene Tickets können mit dieser Bestellung nicht mehr heruntergeladen werden. Ihre Rechnung bleibt verfügbar.",
        "en": "Transferred tickets can no longer be downloaded from this order. Your invoice remains available."
    },
    "Le transfert est fermé pour cette catégorie ou trop proche du début de la séance.": {
        "de": "Die Übertragung ist für diese Kategorie geschlossen oder die Vorstellung beginnt zu bald.",
        "en": "Transfers are closed for this category or it is too close to the start time."
    },
    "Ce billet a déjà servi au contrôle et ne peut plus être transféré.": {
        "de": "Dieses Ticket wurde bereits am Einlass verwendet und kann nicht mehr übertragen werden.",
        "en": "This ticket has already been used for admission and can no longer be transferred."
    },
    "propose": {
        "de": "angeboten",
        "en": "offered"
    },
    "accepte": {
        "de": "angenommen",
        "en": "accepted"
    },
    "retire": {
        "de": "zurückgezogen",
        "en": "withdrawn"
    },
    "expire": {
        "de": "abgelaufen",
        "en": "expired"
    },
    "prepare": {
        "de": "vorbereitet",
        "en": "prepared"
    },
    "en_cours": {
        "de": "in Bearbeitung",
        "en": "in progress"
    },
    "envoye": {
        "de": "gesendet",
        "en": "sent"
    },
    "incertain": {
        "de": "Ergebnis unklar",
        "en": "uncertain result"
    }
}
